import React from "react";
import { List, Datagrid, EmailField, TextField, EditButton } from 'react-admin';

// Guesser impossible car ça fait un appel à /users sans le token, donc 401
export default props => (
  <List {...props} title="Utilisateurs">
      <Datagrid rowClick="edit">
          <EmailField source="email" label="Email"/>
          <TextField source="firstName" label="Prénom"/>
          <TextField source="lastName" label="Nom" />
          <TextField source="certificateUid" label="Identifiant certificat" />
          <EditButton />
      </Datagrid>
  </List>
);
